const SHARED_RAW_CONFIG_KEYS = [
	'VITE_API_HOST',
	'VITE_CHAT_API',
	'VITE_CMS_API_URL',
	'VITE_PARTNER_IDN',
	'VITE_WEB_CALL_CONNECTOR_IDN'
] as const;

const PORTAL_RAW_CONFIG_KEYS = [
	'VITE_ANALYTICS_HOST',
	'VITE_ANALYTICS_KEY',
	'VITE_APP_ENV',
	'VITE_AUTH0_CLIENT_ID',
	'VITE_AUTH0_DOMAIN',
	'VITE_AUTH0_TENANT',
	'VITE_AUTH_CALLBACK_URL',
	'VITE_BUILDER_URL',
	'VITE_CAL_COM_CALL_LINK',
	'VITE_CREATOR_REMOTE_URL',
	'VITE_CREATOR_URL',
	'VITE_CUSTOM_LOGIN_URL',
	'VITE_FLOW_BUILDER_REMOTE_URL',
	'VITE_INTERCOM_APP_ID',
	'VITE_IONOS_PORTAL_URL',
	'VITE_IONOS_PROVISIONING_URL',
	'VITE_IS_WEBRTC_FLOW_ENABLED',
	'VITE_MARKETING_MATERIALS_LINK',
	'VITE_PARTNER_GTM_ID',
	'VITE_PORTAL_CLIENT_SECRET',
	'VITE_PORTAL_SECRET',
	'VITE_SCHEDULE_ROUND_ROBIN_LINK',
	'VITE_SENTRY_DSN',
	'VITE_STRIPE_PUBLIC_KEY',
	'VITE_VIBE_BUILDER_REMOTE_URL',
	'VITE_WEBRTC_BUCKET_URL',
	'VITE_WL_PORTAL_URL'
] as const;

const CREATOR_RAW_CONFIG_KEYS = [
	'VITE_BASE_PATH',
	'VITE_BUILD_MODE',
	'VITE_CREATOR_CLIENT_SECRET',
	'VITE_E2E',
	'VITE_GOOGLE_API_KEY',
	'VITE_IS_WEBRTC_FLOW_ENABLED',
	'VITE_PARTNER_CLIENT_SECRET',
	'VITE_PARTNER_GTM_ID',
	'VITE_PARTNER_INDUSTRY',
	'VITE_WEBRTC_BUCKET_URL',
	'VITE_WL_PORTAL_URL'
] as const;

const VIBE_BUILDER_RAW_CONFIG_KEYS = [
	'VITE_BASE_PATH',
	'VITE_BUILD_MODE',
	'VITE_E2E_REALTIME_MOCK'
] as const;

function uniqueRawConfigKeys(keys: readonly string[]): string[] {
	return [...new Set(keys)];
}

export const APP_CONFIG_SHARED_RAW_CONFIG_KEYS = SHARED_RAW_CONFIG_KEYS;
export const APP_CONFIG_PORTAL_RAW_CONFIG_KEYS = PORTAL_RAW_CONFIG_KEYS;
export const APP_CONFIG_CREATOR_RAW_CONFIG_KEYS = CREATOR_RAW_CONFIG_KEYS;
export const APP_CONFIG_VIBE_BUILDER_RAW_CONFIG_KEYS =
	VIBE_BUILDER_RAW_CONFIG_KEYS;

export const APP_CONFIG_RUNTIME_SURFACE_RAW_CONFIG_KEYS = {
	creator: uniqueRawConfigKeys([
		...APP_CONFIG_SHARED_RAW_CONFIG_KEYS,
		...APP_CONFIG_CREATOR_RAW_CONFIG_KEYS
	]),
	portal: uniqueRawConfigKeys([
		...APP_CONFIG_SHARED_RAW_CONFIG_KEYS,
		...APP_CONFIG_PORTAL_RAW_CONFIG_KEYS,
		...APP_CONFIG_CREATOR_RAW_CONFIG_KEYS
	])
} as const;
